export default __webpack_public_path__ + "static/media/1689.86358ad8.png";